<template>
    <div :class="{ 'reward-center':isCenter,'background-container': showWord, 'content-container': true }" :style="{ backgroundPosition: `top ${wordPosition}` }">
        <div class="content-item-container">
            <div class="content-body">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContentItemContainer",
    props: {
        showWord: {
            type: Boolean,
            default: false
        },
        wordPosition: {
            type: String,
            default: 'left',
            validator: value => ['left', 'right', 'center'].includes(value)
        },
        isCenter: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./function";
.reward-center {
    background-size: 96% !important;
    padding-top: px2rem(60) !important;
}
.background-container {
    background-image: url("../../../assets/images/postalNewCustomer/reward.png");
    background-size: px2rem(416) auto;
    background-repeat: no-repeat;
    padding-top: px2rem(55);
}

.content-container {
    margin: 0 px2rem(24);

    .content-item-container {
        background-color: #d8ffef;
        border-radius: px2rem(50);
        padding: px2rem(20);
        box-shadow: 0 0 px2rem(24) px2rem(16) rgba(154, 234, 198, 0.8);
        box-sizing: border-box;

        .content-body {
            width: 100%;
            height: 100%;
            background: #ffffff;
            border-radius: px2rem(40);
            box-shadow: 0 0 px2rem(8) px2rem(10) #b5ffe1;
        }
    }
}
</style>
